import * as React from 'react';
import { inject, observer } from 'mobx-react';

import { AnalyticsStore, ContextStore, PageStore } from 'bernie-plugin-mobx';
import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';
import { UitkSpacing, UitkSpacingProps } from 'uitk-react-spacing';

import { ErrorStore, InformationCriteriaStore, SearchCriteriaStore } from 'stores';
import {
  isFlightInformation,
  isFlightsSearch,
  isFlightsServicing,
  isFlightsServicingConfirmation,
  trackAnalytics
} from 'utility';
import { AnalyticsType } from 'types/shared';
import { ErrorEmptyState } from '.';
import analyticsWrapper from 'utility/analytics-wrapper';
import TriggerFlightsSearchParams from 'types/shared/trigger-flights-search-params';
import { RouteComponentProps, withRouter } from 'react-router-dom';

interface NoApiResponseProps extends LocalizedComponentProps, RouteComponentProps {
  searchCriteriaStore?: SearchCriteriaStore;
  informationCriteriaStore?: InformationCriteriaStore;
  context?: ContextStore;
  page?: PageStore;
  analytics?: AnalyticsStore;
  errorStore?: ErrorStore;
}

const mainSpacingProps: UitkSpacingProps = {
  margin: { block: 'twelve' },
  padding: { block: 'twelve' }
};

@withLocalization
@inject('context', 'searchCriteriaStore', 'page', 'analytics', 'informationCriteriaStore', 'errorStore')
@observer
export class NoApiResponseComponent extends React.Component<NoApiResponseProps> {
  private retryOnClick = () => {
    const { searchCriteriaStore, history, location, context, page, analytics, errorStore } = this.props;
    let analyticsType: AnalyticsType;

    if (errorStore?.redirectToStorefront) {
      analyticsType = {
        __typename: 'FlightsAnalytics',
        linkName: 'Click on retry button on FSR',
        referrerId: 'FLT.SR.ErrorPage.Retry.Clicked'
      };
      trackAnalytics(analyticsType, analytics);
      history.replace('/Flights');
    }

    if (isFlightInformation(page)) {
      analyticsType = {
        __typename: 'FlightsAnalytics',
        linkName: 'page.Flight.FIS.Error',
        referrerId: 'FLT.FIS.Servererror.retry.Clicked'
      };
    }

    if (isFlightsServicing(page)) {
      analyticsType = {
        __typename: 'FlightsAnalytics',
        linkName: 'page.Flight.SRV.Credit.Error',
        referrerId: 'FLT.SRV.Credit.ErrorPage.Retry.Clicked'
      };
    }

    if (isFlightsServicingConfirmation(page)) {
      analyticsType = {
        __typename: 'FlightsAnalytics',
        linkName: 'page.Flight.SRV.CP.Credit.Error',
        referrerId: 'FLT.SRV.CP.Credit.ErrorPage.Retry.Clicked'
      };
    }

    if (analytics && analyticsType) {
      trackAnalytics(analyticsType, analytics);
    }

    if (isFlightsSearch(page) && searchCriteriaStore) {
      const triggerSearchParams: TriggerFlightsSearchParams = {
        history,
        location,
        context,
        shouldForce: true,
        replaceHistory: true,
        fetchSearchForm: false
      };
      searchCriteriaStore.triggerSearch(triggerSearchParams);
    } else {
      window.location.reload();
    }
  };

  public render() {
    const headingText = this.props.l10n.formatText('server.error.heading');
    const bodyText = this.props.l10n.formatText('server.error.message');
    const buttonText = this.props.l10n.formatText('server.error.retry.button.text');
    const { analytics, errorStore, page } = this.props;
    if (errorStore?.redirectToStorefront) {
      const searchAnalyticsData = [
        {
          adobeMappedData: {
            channel: 'Flight',
            pageName: page.pageId.substring(0, page.pageId.indexOf(','))
          },
          context: {
            pageIdentity: {
              lineOfBusiness: 'F',
              pageIdentifier: page.pageId.substring(0, page.pageId.indexOf(',')),
              funnelLocation: 20
            }
          },
          version: '3.14.0',
          applicationName: 'bex-api-flights'
        }
      ];
      analyticsWrapper.setAnalyticsPayload(searchAnalyticsData);
      analyticsWrapper.publishSearchAnalyticsPayload(analytics);
      analyticsWrapper.markPageUsable(
        {
          microMessages: [
            {
              schemaName: 'error',
              messageContent: {
                errorCode: 'FLT.SR.ErrorPage.URLError'
              }
            }
          ]
        },
        analytics
      );
    }

    return (
      <UitkSpacing margin={mainSpacingProps.margin} padding={mainSpacingProps.padding}>
        <main data-test-id="no-api-response">
          <ErrorEmptyState
            icon="search"
            title={headingText}
            body={bodyText}
            buttonText={buttonText}
            clickHandler={this.retryOnClick}
            headingTag="h1"
          />
        </main>
      </UitkSpacing>
    );
  }
}

export const NoApiResponse = withRouter(NoApiResponseComponent);
